import { useQuery } from '@tanstack/react-query';

import { queries } from '../../../common/api/queryKeys/queries';

export const useUser = () => {
    return useQuery(queries.members.currentUser);
};
